"use client"

import { Guitar } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `GuitarIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const GuitarIcon = component(Icon)({ as: Guitar })
